// extracted by mini-css-extract-plugin
export default {"border":"components_border__x2h5v"};